import React, { FC, HTMLAttributes } from "react";
import { CTA_SIZE, CTA_TYPE } from "../../../data/constants";
import CtaComponent from "../cta";

interface CtaProps {
  text: string;
  customClass?: string;
}

export const NEXT = 'next';
export const PREV = 'prev';

interface PaginationProps extends HTMLAttributes<HTMLDivElement> {
  prevCta: CtaProps;
  nextCta: CtaProps;
  parentClass?: string;
  getDataFn: any;
  prevPagination: any[];
  paginationData:any;
}

const CustomPagination: FC<PaginationProps> = (props): React.JSX.Element => {

  const prevCtaProps = {
    ctaSize: CTA_SIZE.medium,
      customClass: props?.prevCta?.customClass || "",
      ctaType: CTA_TYPE.secondary_cta,
      ctaText: props?.prevCta?.text || 'Previous',
      isDisabled: props.prevPagination.length === 0,
      onCtaClick: () => props.getDataFn(PREV),
  }
 
  const nextCtaProps = {
    ctaSize: CTA_SIZE.medium,
      customClass: props?.nextCta?.customClass || "",
      ctaType: CTA_TYPE.secondary_cta,
      ctaText: props?.nextCta?.text || 'Next',
      isDisabled: Object.keys(props.paginationData).length === 0,
      onCtaClick: () => props.getDataFn(NEXT),
  }
  
  return (
    <div className={`flex ${props.parentClass}`}>
      <CtaComponent {...prevCtaProps} />
      <CtaComponent {...nextCtaProps} />
    </div>
  );
};

export default CustomPagination;